/**
 * Global promo countdown (theme-side) — ticker only.
 *
 * The [timer] token is replaced SERVER-SIDE (snippets/lhg-promo-timer.liquid)
 * with a <span class="lhg-promo-countdown" data-ends="…"> whose value is already
 * computed, so there is no flash and no hide/reveal. This script just keeps each
 * such span ticking, and clears intervals when spans are removed (Algolia
 * re-renders, etc.). Loaded only when a promo is active.
 *
 * Independent of the LHG-Badges app, which owns product-badge timers.
 */
(function () {
  var IS_FR = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  var UNIT = IS_FR ? { d: 'j', h: 'h', m: 'm', s: 's' } : { d: 'd', h: 'h', m: 'm', s: 's' };

  function pad2(n) {
    return String(Math.max(0, n | 0)).padStart(2, '0');
  }

  function formatRemaining(endMs, nowMs) {
    var diff = Math.max(0, Math.floor((endMs - nowMs) / 1000));
    var days = Math.floor(diff / 86400); diff -= days * 86400;
    var hours = Math.floor(diff / 3600); diff -= hours * 3600;
    var minutes = Math.floor(diff / 60);
    var seconds = diff - minutes * 60;
    if (days > 0) return pad2(days) + UNIT.d + ' ' + pad2(hours) + UNIT.h + ' ' + pad2(minutes) + UNIT.m + ' ' + pad2(seconds) + UNIT.s;
    if (hours > 0) return pad2(hours) + UNIT.h + ' ' + pad2(minutes) + UNIT.m + ' ' + pad2(seconds) + UNIT.s;
    return pad2(minutes) + UNIT.m + ' ' + pad2(seconds) + UNIT.s;
  }

  function start(span) {
    if (span.dataset.lhgTicking === 'true') return;
    var endMs = Date.parse(span.getAttribute('data-ends'));
    if (!isFinite(endMs)) return;
    span.dataset.lhgTicking = 'true';

    function tick() {
      var now = Date.now();
      if (now < endMs) {
        span.textContent = formatRemaining(endMs, now);
        return;
      }
      // Promo just ended: restore the original content. Remove the promo wrapper
      // and reveal its hidden fallback (manual promo bar / standard collection
      // description). If there is no fallback, the promo wrapper is simply
      // removed. Falls back to a 00:00 display if there is no swap wrapper.
      clearInterval(handle);
      var swap = span.closest ? span.closest('[data-lhg-promo-swap]') : null;
      if (swap && swap.parentNode) {
        var fallback = swap.parentNode.querySelector('[data-lhg-promo-fallback]');
        if (fallback) fallback.removeAttribute('hidden');
        swap.parentNode.removeChild(swap);
        return;
      }
      span.textContent = formatRemaining(endMs, endMs);
      span.classList.add('lhg-promo-countdown--expired');
    }
    tick();
    var handle = setInterval(tick, 1000);
    span.dataset.lhgTimerHandle = String(handle);
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches('.lhg-promo-countdown')) start(root);
    root.querySelectorAll('.lhg-promo-countdown').forEach(start);
  }

  function clearTimersIn(node) {
    if (!node || node.nodeType !== 1) return;
    var spans = [];
    if (node.matches && node.matches('.lhg-promo-countdown')) spans.push(node);
    if (node.querySelectorAll) node.querySelectorAll('.lhg-promo-countdown').forEach(function (s) { spans.push(s); });
    spans.forEach(function (s) {
      var h = parseInt(s.dataset.lhgTimerHandle, 10);
      if (!isNaN(h)) clearInterval(h);
    });
  }

  function init() {
    scan(document.body);
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); });
        m.removedNodes.forEach(function (n) { clearTimersIn(n); });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('beforeunload', function () { observer.disconnect(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
